import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Facebook, Instagram, Mail } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import WhiteLogo from "@/assets/images/logo/White_Version.png";
const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* Main Footer Content */}
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Logo & Tagline */}
          <div className="lg:col-span-1">
            <img src={WhiteLogo} alt="RealEsy" className="h-24" />
            <p className="text-gray-400 leading-relaxed">
              The all-in-one platform for real estate operations, signage, and vendor collaboration.
            </p>

            {/* Social Media Icons */}
            <div className="flex gap-4 mt-6">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-gray-700 rounded-lg flex items-center justify-center transition-colors"
              >
                <FontAwesomeIcon icon={faXTwitter} className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-blue-700 rounded-lg flex items-center justify-center transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Features Links */}
          <div>
            <h3 className="text-white font-medium mb-4">Features</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/features/installations" className="hover:text-white transition-colors">
                  Installations
                </Link>
              </li>
              <li>
                <Link to="/features/removals" className="hover:text-white transition-colors">
                  Removals
                </Link>
              </li>
              <li>
                <a href="#inventory" className="hover:text-white transition-colors">
                  Inventory
                </a>
              </li>
              <li>
                <Link to="/features/workdrive" className="hover:text-white transition-colors">
                  WorkDrive
                </Link>
              </li>
              {/* <li>
                <Link to="/features/smartread" className="hover:text-white transition-colors">
                  SmartRead AI
                </Link>
              </li>
              <li>
                <a href="#smartshow" className="hover:text-white transition-colors">
                  SmartShow AI
                < /a>
              </li> */}
              <li>
                <Link to="/features/reporting" className="hover:text-white transition-colors">
                  Reporting
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-white font-medium mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a href="#partners" className="hover:text-white transition-colors">
                  Partners
                </a>
              </li>
              <li>
                <a href="#blog" className="hover:text-white transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="#faqs" className="hover:text-white transition-colors">
                  FAQs
                </a>
              </li>
              <li>
                <a href="#support" className="hover:text-white transition-colors">
                  Support Docs
                </a>
              </li>
              <li>
                <a href="#help" className="hover:text-white transition-colors">
                  Help Center
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Support */}
          <div>
            <h3 className="text-white font-medium mb-4">Contact & Support</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-blue-400" />
                <a href="mailto:help@realesy.com" className="hover:text-white transition-colors">
                  help@realesy.com
                </a>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Legal Links */}
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="hover:text-white transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="hover:text-white transition-colors">
                Terms of Service
              </Link>
            </div>

            {/* Copyright */}
            <p className="text-sm text-gray-500 text-center md:text-right max-w-3xl">
              © {new Date().getFullYear()} Signage Installation Management, LLC. All rights
              reserved. RealEsy, the RealEsy logo, and all related product names are trademarks of
              Signage Installation Management, LLC.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
